









import VueOptions from '@utils/VueOptions'
import FormBuilder from '@ui/FormBuilder/FormBuilder'
import AudienceCreativeFields from '@ui/FormBuilder/ResourceFields/CreativeFields'

settings =
  name: 'AudienceCreativeForm'

  vue:
    props: ['form']

    components: {
      FormBuilder,
    }

    computed:
      contextForAudienceCreativeFields: ->
        options:
          primary_type: @toSelectOptions(@$store.marketplace?.listing?.types)
          types: @toSelectOptions(@$store.marketplace?.listing?.types)
          preferred_brand_categories: @toSelectOptions(@$store.marketplace?.brand?.categories)
        inputProps:
          inventory_capacity:
            segments: ['default']

      audienceCreativeFields: ->
        AudienceCreativeFields(@contextForAudienceCreativeFields)

export default VueOptions.vue settings
